import React, { useEffect, useState } from 'react';
import { useAuth } from '@shootout-comps/core';
import { useLang } from '@shootout-comps/i18n';

function GoogleIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">
      <path fill="#4285F4" d="M17.64 9.2c0-.64-.06-1.25-.16-1.84H9v3.48h4.84a4.14 4.14 0 0 1-1.8 2.72v2.26h2.9c1.7-1.57 2.7-3.87 2.7-6.62z" />
      <path fill="#34A853" d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.9-2.26c-.81.54-1.84.86-3.06.86-2.35 0-4.34-1.59-5.05-3.72H.96v2.33A9 9 0 0 0 9 18z" />
      <path fill="#FBBC05" d="M3.95 10.7A5.4 5.4 0 0 1 3.67 9c0-.59.1-1.17.28-1.7V4.97H.96A9 9 0 0 0 0 9c0 1.45.35 2.83.96 4.03l2.99-2.33z" />
      <path fill="#EA4335" d="M9 3.58c1.32 0 2.51.46 3.44 1.35l2.58-2.58C13.47.89 11.43 0 9 0A9 9 0 0 0 .96 4.97l2.99 2.33C4.66 5.17 6.65 3.58 9 3.58z" />
    </svg>
  );
}

function FacebookIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">
      <path fill="#fff" d="M12.5 9.5H10V17H7V9.5H5V7h2V5.5C7 3.6 8 2 10.3 2H12.5v2.4h-1.4c-.6 0-1.1.3-1.1 1V7h2.5l-.3 2.5z" />
    </svg>
  );
}

const baseBtnStyle: React.CSSProperties = {
  width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.6rem',
  padding: '0.75rem', borderRadius: '8px', fontSize: '0.88rem', fontWeight: 600, cursor: 'pointer',
  minHeight: '48px', border: '1px solid rgba(255,255,255,0.15)',
};

export default function OAuthButtons() {
  const { startOAuth } = useAuth();
  const { t } = useLang();
  const [googleEnabled, setGoogleEnabled] = useState(false);
  const [facebookEnabled, setFacebookEnabled] = useState(false);

  useEffect(() => {
    fetch('/api/settings/public')
      .then(r => r.json())
      .then((d: { googleLoginEnabled?: boolean; facebookLoginEnabled?: boolean }) => {
        setGoogleEnabled(d.googleLoginEnabled !== false);
        setFacebookEnabled(d.facebookLoginEnabled !== false);
      })
      .catch(() => { /* provider buttons stay hidden if settings can't be fetched */ });
  }, []);

  if (!googleEnabled && !facebookEnabled) return null;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.6rem' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', color: 'var(--chalk-dim)', fontSize: '0.72rem', textTransform: 'uppercase', letterSpacing: '0.08em' }}>
        <div style={{ flex: 1, height: 1, background: 'rgba(255,255,255,0.15)' }} />
        {t.orContinueWith}
        <div style={{ flex: 1, height: 1, background: 'rgba(255,255,255,0.15)' }} />
      </div>

      {googleEnabled && (
        <button type="button" onClick={() => startOAuth('google')} style={{ ...baseBtnStyle, background: '#fff', color: '#3c4043' }}>
          <GoogleIcon /> {t.continueWithGoogle}
        </button>
      )}

      {facebookEnabled && (
        <button type="button" onClick={() => startOAuth('facebook')} style={{ ...baseBtnStyle, background: '#1877F2', color: '#fff', border: '1px solid #1877F2' }}>
          <FacebookIcon /> {t.continueWithFacebook}
        </button>
      )}
    </div>
  );
}
